$(function () {
    currLoc = $(location).attr('pathname');
    /*console.log(currLoc);*/


    $('.page-nav a').each(function () {
        if ($(this).attr("href") == window.location.pathname) {
            $(this).parent().addClass("active");
        }
    });
});